import React from "react";
import { Github, Twitter, Linkedin, Mail } from "lucide-react";

export const Footer = ({ onConsult }) => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#05030A] border-t border-transparent"
    >
      <div className="footer-accent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_efficiency-systems/artifacts/guzhatny_FLOWBASE.png"
                alt="FlowBase"
                className="fb-logo-img"
              />
              <span className="neon-logo text-2xl">FlowBase</span>
            </a>
            <p className="mt-5 text-sm text-white/55 leading-relaxed max-w-sm">
              A modern tech agency engineering the digital infrastructure of
              tomorrow — through web, AI, and automation.
            </p>
            <button
              data-testid="footer-consult-btn"
              onClick={onConsult}
              className="mt-6 btn-neon rounded-full h-11 px-6 text-sm font-semibold inline-flex items-center"
            >
              Start a project →
            </button>
          </div>

          <FooterColumn
            title="Services"
            links={[
              "AI & Automation",
              "Web Development",
              "Efficiency Systems",
              "UI/UX Design",
            ]}
          />
          <FooterColumn
            title="Company"
            links={["About", "Process", "Careers", "Contact"]}
          />
          <FooterColumn
            title="Resources"
            links={["Case Studies", "Blog", "Pricing", "FAQ"]}
          />
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
          <p className="text-xs text-white/40 font-mono-ui">
            © {new Date().getFullYear()} FlowBase Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <Social icon={Github} label="github" />
            <Social icon={Twitter} label="twitter" />
            <Social icon={Linkedin} label="linkedin" />
            <Social icon={Mail} label="email" />
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterColumn = ({ title, links }) => (
  <div className="md:col-span-2">
    <h4 className="text-xs uppercase tracking-[0.22em] text-white/45 mb-4">
      {title}
    </h4>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l}>
          <a
            href="#"
            className="text-sm text-white/70 hover:text-[#B026FF] transition-colors"
          >
            {l}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const Social = ({ icon: Icon, label }) => (
  <a
    href="#"
    aria-label={label}
    data-testid={`social-${label}`}
    className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:border-[#B026FF]/60 hover:bg-[#B026FF]/10 transition"
  >
    <Icon size={15} />
  </a>
);
